import { FormattedMessage } from 'react-intl';
import { NavLink } from 'react-router-dom';

import FountainLogo from '@/assets/icons/fountain-logo.svg';
import SourceLogo from '@/assets/icons/source-logo.svg';
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
  SidebarMenuButton,
} from '@/components/ui/sidebar';
import { Typography } from '@/components/ui/typography';
import { useAuthContext } from '@/contexts/auth-context';
import { useNavigationPaths } from '@/hooks/use-navigation-paths';

export function AppSidebar() {
  const { dashboardPath, allOpeningsPath } = useNavigationPaths();
  const { account, brandLogoUrl } = useAuthContext();
  const { name } = account ?? {};

  const getTypographyVariant = (isActive: boolean) =>
    isActive ? 'body1' : 'subtitle1';

  return (
    <Sidebar>
      <SidebarHeader className="border-fx-neutral-200 flex h-[56px] items-start justify-center border-b px-4 [clip-path:inset(0_16px_0_16px)]">
        <img src={FountainLogo} alt="Fountain" className="h-[20px] w-[125px]" />
      </SidebarHeader>

      <SidebarContent className="py-4 px-2">
        <div className="flex items-center gap-2 p-1">
          <img src={SourceLogo} alt="Source" />
          <Typography variant="body2">
            <FormattedMessage defaultMessage="Source" />
          </Typography>
        </div>

        <div className="py-2">
          <NavLink to={dashboardPath}>
            {({ isActive }) => (
              <SidebarMenuButton isActive={isActive}>
                <span className="w-8" />
                <Typography variant={getTypographyVariant(isActive)}>
                  <FormattedMessage defaultMessage="Dashboard" />
                </Typography>
              </SidebarMenuButton>
            )}
          </NavLink>

          <NavLink to={allOpeningsPath}>
            {({ isActive }) => (
              <SidebarMenuButton isActive={isActive}>
                <span className="w-8" />
                <Typography variant={getTypographyVariant(isActive)}>
                  <FormattedMessage defaultMessage="All Openings" />
                </Typography>
              </SidebarMenuButton>
            )}
          </NavLink>
        </div>
      </SidebarContent>

      <SidebarFooter className="flex flex-row items-center gap-2">
        {brandLogoUrl && (
          <img src={brandLogoUrl} alt="Brand logo" className="h-8 w-8" />
        )}
        <Typography variant="body1">{name}</Typography>
      </SidebarFooter>
    </Sidebar>
  );
}
